<template>
  <tr class="app-table__app-table-row__loading">
    <app-table-cell v-if="selectButton" />
    <app-table-cell
      v-for="(column, index) in columns"
      :first="index === 0"
      :last="index === columns.length - 1"
      :key="row + column.label"
      :column="column"
    />
  </tr>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      required: true
    },
    row: {
      type: Number,
      required: true
    },
    selectButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
